// extracted by css-extract-rspack-plugin
export default {"spaceXSmall":"8px","aiContainer":"sense-ai__aiContainer___Xkis6"};